import axios from 'axios'

export default {
  createCardInfo (payload) {
    return axios.post(`/api/card`, payload)
  },
  updateCardInfo (id, payload) {
    return axios.patch(`/api/card/${id}/update`, payload)
  },
  deleteCardInfo (id) {
    return axios.delete(`/api/card/${id}/destroy`)
  },
  fetchCreditCardsDetail (companyId) {
    return axios.get(`/api/card/company/${companyId}`)
  },
  fetchProductItemsOrderSummary (selectedGroupBy, selectedSortBy, activeDraftOrderId, changedSince = null) {
    return axios.get('/api/checkout/order-summary/get-product-items', {
      params: {
        group_by: selectedGroupBy,
        sort_by: selectedSortBy,
        order_id: activeDraftOrderId,
        // with_meta asks for the envelope: the sync marker to pass back next time, plus the
        // order totals, so a delta refresh doesn't need the heavy unit-summary report.
        with_meta: 1,
        ...(changedSince ? { changed_since: changedSince } : {})
      }
    })
  },
  orderHasProducts (id, payload) {
    return axios.patch(`/api/order/order-has-product/update`, payload)
  },
  deleteBulkProductFromOrder (payload) {
    return axios.post('/api/order/remove-products', payload)
  },
  duplicateToOtherProducts (payload) {
    return axios.post('/api/order/quantities/duplicate', payload)
  },
  fetchOrderReview (orderId) {
     return axios.get(`/api/checkout/order-review/${orderId}`)
  },
  updateShipComplete (payload) {
     return axios.post('/api/checkout/ship-complete', payload)
  },
  getDigitalCatalogSelectedProducts(params) {
    const accessToken = localStorage.getItem('digital_catalog_access_token')
    return axios.get('/api/digital-catalog/selected-products', {
        params,
        headers: {
            'X-Access-Token': accessToken
        }
    })
  }

}
